import { render, staticRenderFns } from "./mv-card-signup.vue?vue&type=template&id=6b6c4064&scoped=true"
import script from "./mv-card-signup.vue?vue&type=script&lang=js"
export * from "./mv-card-signup.vue?vue&type=script&lang=js"
import style0 from "./mv-card-signup.vue?vue&type=style&index=0&id=6b6c4064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6c4064",
  null
  
)

export default component.exports